import { useEffect, useState } from 'react';
import { settingsApi, LogoSettings } from '../services/settingsApi';

export function useAppLogo(authenticated: boolean) {
  const [logo, setLogo] = useState<LogoSettings | null>(null);

  useEffect(() => {
    let cancelled = false;

    const loadLogo = async () => {
      try {
        const data = authenticated
          ? await settingsApi.getEffectiveLogoSettings()
          : await settingsApi.getPublicLogoSettings();
        if (!cancelled) {
          setLogo(data);
        }
      } catch {
        if (!cancelled) {
          setLogo(null);
        }
      }
    };

    loadLogo();
    return () => {
      cancelled = true;
    };
  }, [authenticated]);

  return logo;
}
